module.exports = __webpack_public_path__ + "img/digital_2.7b1f331a.png";